import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Download } from 'lucide-react';
import type { OrderSummary } from '../../../../infrastructure/OMSClient';
import { downloadParxlCSV, getUKOrderCount } from '../utils/parxlCsvExport';

interface ParxlTemplateModalProps {
  readonly show: boolean;
  readonly onHide: () => void;
  readonly orders: OrderSummary[];
}

function getTodayString(): string {
  const today = new Date();
  return today.toISOString().split('T')[0] ?? '';
}

export function ParxlTemplateModal({ show, onHide, orders }: ParxlTemplateModalProps) {
  const today = getTodayString();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);

  const filteredOrders = orders.filter((order) => {
    const orderDate = new Date(order.orderDate);
    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    return orderDate >= start && orderDate <= end;
  });

  const ukOrderCount = getUKOrderCount(filteredOrders);

  const handleDownload = () => {
    downloadParxlCSV(filteredOrders, startDate, endDate);
    onHide();
  };

  const handleShow = () => {
    setStartDate(today);
    setEndDate(today);
  };

  return (
    <Modal show={show} onHide={onHide} onShow={handleShow} centered>
      <Modal.Header closeButton>
        <Modal.Title>Download Parxl Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <div className="d-flex gap-3 mb-3">
            <Form.Group className="flex-1">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="flex-1">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="p-3 bg-light rounded">
            <p className="mb-1">
              <strong>Orders in range:</strong> {filteredOrders.length}
            </p>
            <p className="mb-0">
              <strong>GB Orders (to download):</strong> {ukOrderCount}
            </p>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleDownload}
          className="d-flex align-items-center gap-2"
        >
          <Download size={16} />
          Download Template
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

